import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PageStateService {
  hideSubscribePanel: boolean = false;
}
